import { gql } from "@apollo/client";

export const CREATE_ORDER_AHEAD_LOCATION = gql`
  mutation CreateOrderAheadLocation($input: locations_order_ahead_insert_input!) {
    insert_locations_order_ahead_one(object: $input) {
      id
    }
  }
`;

export const UPDATE_ORDER_AHEAD_LOCATION = gql`
  mutation update_locations_order_ahead($input: locations_order_ahead_set_input, $where: locations_order_ahead_bool_exp!) {
    update_locations_order_ahead(_set: $input, where: $where) {
      returning {
        id
      }
    }
  }
`;

export const DELETE_ORDER_AHEAD_LOCATION = gql`
   mutation DeleteOrderAheadLocation($id: Int!) {
    delete_locations_order_ahead_by_pk(id: $id) {
      id
    }
  }
`;
